import { Navigate } from 'react-router-dom';
import routeConstants from 'routes/route.constants';
import { isAuthenticated } from './helpers';

const RedirectToHome = () => {
  // If user is authenticated, redirect to dashboard
  // If not authenticated, redirect to home page
  const isUserLoggedIn = isAuthenticated();
  
  return <Navigate to={isUserLoggedIn ? routeConstants.DASHBOARD : '/'} replace />;
};

export default RedirectToHome;
